export const getSauvignonBlancFranceData = () => ({
  name: "Sauvignon Blanc",
  country: "France",
  description: "Le Sauvignon Blanc est principalement cultivé dans la vallée de la Loire, produisant des vins blancs secs et vifs.",
  regions: [
    { name: "Sancerre", area: "2,800 ha", percentage: "35%", description: "Vins minéraux" },
    { name: "Pouilly-Fumé", area: "2,200 ha", percentage: "28%", description: "Vins fumés" },
    { name: "Touraine", area: "1,800 ha", percentage: "23%", description: "Vins de terroir" },
    { name: "Centre-Loire", area: "800 ha", percentage: "10%", description: "Usage diversifié" },
    { name: "Autres", area: "200 ha", percentage: "4%", description: "Dispersé dans la Loire" }
  ],
  mapAreas: [
    { region: "Sancerre", x: 50, y: 25, color: "#4B164C", size: 6 },
    { region: "Pouilly-Fumé", x: 51, y: 26, color: "#6d2c7a", size: 5 },
    { region: "Touraine", x: 45, y: 35, color: "#8a4a8a", size: 4 },
    { region: "Centre-Loire", x: 48, y: 28, color: "#a768a6", size: 3 }
  ],
  subregions: {
    loire: {
      name: "Loire",
      description: "Le Sauvignon Blanc de la Loire produit des vins blancs secs, vifs et très expressifs.",
      characteristics: {
        aromas: "Agrumes, buis, fleurs blanches, notes minérales",
        body: "Corps léger à moyen",
        acidity: "Acidité vive et rafraîchissante",
        aging: "Vieillissement court à moyen (3-8 ans)"
      },
      terroir: {
        climate: "Climat océanique tempéré",
        soil: "Sols calcaires et silex",
        viticulture: "Rendements modérés, vendanges manuelles"
      },
      differentiators: [
        "Fraîcheur et vivacité uniques",
        "Notes de buis caractéristiques",
        "Minéralité marquée",
        "Équilibre parfait acidité-fruité"
      ],
      foodPairing: "Poissons, fruits de mer, fromages de chèvre, salades"
    }
  }
}); 